import React from 'react'
import { Row, Col } from 'react-bootstrap'
import '../styles/general.css'

function Footer() {
  return (
    <div>
        {/* ########### PRE FOOTER CARD ######### */}
      <div className='py-5' style={{backgroundColor: '#E7E7E7'}}>
        <div className='structure-container py-5'>
          <Row className='m-0'>
            <Col md={4} className='pre-footer-nav align-items-center px-5'>
            <h1 className='normal-title fs-3'>Resources</h1>
              <a href="">Contact us</a>
              <a href="https://data.iadb.org/api/action/datastore_search?resource_id=6c9d4ecc-4f05-4f63-9539-31f021f70c28" target='_blank'>Web API</a>
              <a href="https://mydata.iadb.org/Indicator-Catalog/Latin-Macro-Watch-Dataset/tbnd-z94f/about_data" target='_blank'>IDB My Data</a>
            </Col>
            <Col md={8} className='pre-footer-nav p-5'>
              <h1 className='normal-title fs-3'>For citation use:</h1>
              <p>Inter-American Development Bank, 2019, Latin Macro Watch Dataset, IDB Open Data,<a style={{overflowWrap: 'break-word'}} href="https://doi.org/10.60966/2n3c3oib" target='_blank'>https://doi.org/10.60966/2n3c3oib</a></p>
            </Col>
          </Row>
        </div>
      </div>

    </div>
  )
}



export default Footer
